import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home'
import AllGalery from '../components/gallery/AllGalery'
import GalleryPage from '../components/gallery/GalleryPage'
import Page404 from '../components/Page404'
import Portfolio from '../components/portfolio/Portfolio'
import Page from '../components/gallery/Page'

Vue.use(VueRouter)
const router = new VueRouter({
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  },
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: {title: 'Címlap | NK creative '},
      component: Home
    },
    {
      path: '/en',
      name: 'Home',
      meta: {title: 'Home | NK creative '},
      component: Home
    },
    {
      path: '/galeria',
      name: 'All gallery',
      meta: {title: 'Galériák | NK creative '},
      component: AllGalery
    },
    {
      path: '/en/galeria',
      meta: {title: 'Galleries | NK creative '},
      name: 'All gallery',
      component: AllGalery
    },
    {
      path: '/portfolio',
      name: 'portfolio',
      meta: {title: 'Portfólió | NK creative '},
      component: Portfolio
    },
    {
      path: '/en/portfolio',
      meta: {title: 'Portfolio | NK creative  '},
      name: 'portfolio en',
      component: Portfolio
    },
    {
      path: '/galeria/:slug',
      name: 'GalleryPage',
      component: GalleryPage
    },
    {
      path: '/oldalak/:slug',
      name: 'Page',
      component: Page
    },
    {
      path: 'en/pages/:slug',
      name: 'Page',
      component: Page
    },
    {
      path: '/en/galeria/:slug',
      name: 'GalleryPage',
      component: GalleryPage
    },
    {

      path: '*',
      name: '404',
      component: Page404

    }
  ]
})
const DEFAULT_TITLE = 'NK creative'
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE
  })
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js